
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M14.9099 6.70998C14.5199 6.31998 13.8899 6.31998 13.4999 6.70998L8.90993 11.3C8.51993 11.69 8.51993 12.32 8.90993 12.71L13.4999 17.3C13.8899 17.69 14.5199 17.69 14.9099 17.3C15.2999 16.91 15.2999 16.28 14.9099 15.89L11.0299 12L14.9099 8.11998C15.2899 7.72998 15.2899 7.08998 14.9099 6.70998Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-navigate-before`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNavigateBefore

    ```js
    <b-new-b-icon-navigate-before />
    ```
</docs>


